import { Component } from '@angular/core';
//import {FlexLayoutModule} from "@angular/flex-layout";
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts